module.exports = __webpack_public_path__ + "static/media/logo-white.544a5566.svg";